import { IMetaResource } from '@enuan/chat__utils';
import { Details } from '../../../message/content';
import { Download } from './Download';

export const DocBalloonContent = ({ data }: { data: IMetaResource }) => {
	return (
		<Details resource={data}>
			<Download data={data} />
		</Details>
	);
};
